import { Select } from "antd";
import { Option } from "antd/lib/mentions";
import { packageMonthOptions } from "../../constants";

// What each plan includes. The ids are the ones the admin panel already knows:
// basic / exc (Executivo) / vip (Premium). Each plan has everything the one before it has.
const PLANS = [
    { id: 'basic', name: 'Plano Básico', color: 'basic', features: ['Página Web', 'Aplicativo'] },
    { id: 'exc', name: 'Plano Executivo', color: 'exc', features: ['Página Web', 'Aplicativo', 'Instagram', 'Facebook'] },
    { id: 'vip', name: 'Plano Premium', color: 'vip', features: ['Página Web', 'Aplicativo', 'Instagram', 'Facebook', 'TikTok', 'WhatsApp Status'] },
];

const PackageComponent = ({ packageMonths, setPackageMonths, packageAmounts, getPackageAmount, changeSelectedPackage, selectedPackage, ...props }) => {
    return (
        <div className='packages-container'>
            <div className='package-items card p-4 m-4'>
                <div className="form-group col-sm-12 col-md-6 col-lg-4">
                    <label className="mb-1 mt-1 heading-font">Selecionar meses</label>
                    <div className="col-12">
                        <Select
                            placeholder="Selecionar meses"
                            style={{ width: "100%" }}
                            value={packageMonths}
                            onChange={(e) => {
                                setPackageMonths(e);
                            }}
                        >
                            {packageMonthOptions.map((m) => (
                                <Option value={m} key={"months-" + m}>{m === 12 ? '12 Meses (1 Ano)' : m + ' Meses'}</Option>
                            ))}
                        </Select>
                    </div>
                </div>
                <div className="row">
                    {PLANS.filter((plan) => packageAmounts[plan.id] !== undefined).map((plan) => {
                        const selected = selectedPackage == plan.id;
                        const colorClass = plan.color + '-package-color';
                        return (
                            <div className='package col-md-4' key={plan.id} onClick={() => {
                                changeSelectedPackage(plan.id);
                            }}>
                                <div className='item'>
                                    {selected && <div className={plan.id == 'basic' ? 'selected-header package' : 'selected-header package ' + plan.color + '-package-bg'}>
                                        <p className='m-0 heading-font'>Selecionado</p>
                                    </div>}
                                    <div className={'package-body pb-2' + (plan.id == 'basic' ? '' : ' ' + plan.color + '-package-border') + (selected ? ' active' : '')}>
                                        <div className='text-center'>
                                            <h5 className={'heading-font mt-2 mb-2 ' + colorClass}>{plan.name}</h5>
                                        </div>
                                        <div className='text-center'>
                                            <h2 className='m-0'><span className={'package-currency ' + colorClass}>Kz</span>{getPackageAmount(plan.id)}</h2>
                                        </div>
                                        <div className='text-left'>
                                            <h5 className='m-0 pr-2' style={{ textAlign: 'right', paddingRight: 10 }}>{packageMonths} Meses</h5>
                                        </div>
                                        <div className='package-features pt-2'>
                                            {plan.features.map((feature) => (
                                                <div className='package-feature' key={plan.id + '-' + feature}>
                                                    <p>
                                                        <i className={'fa fa-check feature-icon ' + colorClass}></i> {feature}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default PackageComponent;
